import axios from 'axios'
import { uuidv4 } from '@/helpers/uuid'

// Define mutation types
const ADD_SERVICE = 'ADD_SERVICE'
const REMOVE_SERVICE = 'REMOVE_SERVICE'
const SET_SERVICES = 'SET_SERVICES'
const UPDATE_SERVICE = 'UPDATE_SERVICE'
const RESET = 'RESET'

// API Endpoints
export const BASE_URL = 'api/ServiceRegistry/Services'
const GET_SERVICES_URL = `${BASE_URL}`
const POST_SERVICE_URL = `${BASE_URL}`
const UPDATE_SERVICE_URL = `${BASE_URL}`
const DELETE_SERVICE_URL = `${BASE_URL}`
const VALIDATE_SERVICE_URL = `${BASE_URL}/Validate`
const PING_SERVICES_URL = `${BASE_URL}/Ping`
const EXECUTE_SERVICE_URL = `${BASE_URL}/Execute`
const BULK_INSTALL_SERVICES_URL = `${BASE_URL}/BulkInstall`


// Subpath should begin with a slash
const EXECUTE_SERVICE_PROXY_URL = ({ serviceId, serviceLink, subpath }) => {
  if (serviceId) return `${BASE_URL}/ExecuteProxy/${serviceId}${subpath}`
  else return `${BASE_URL}/ExecuteProxy/ServiceLink/${serviceLink}${subpath}`
}

const SECOND = 1000
const MINUTE = 60 * SECOND
export const PING_INTERVAL = 5 * MINUTE

let initialState = () => ({
  services: [],
})

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async bulkInstallServices(_, {
      serviceIds,
      tenantIds,
    }) {
      try {
        let response = await axios.post(BULK_INSTALL_SERVICES_URL, {
          serviceIds,
          tenantIds,
        })
        return response.data
      } catch (error) {
        throw error.response.data
      }
    },
    async addService({
      commit,
    }, service) {
      try {
        let response = await axios.post(POST_SERVICE_URL, service)
        commit(ADD_SERVICE, response.data)
      } catch (error) {
        throw error.response.data
      }
    },
    deleteService({
      commit,
    }, service) {
      return new Promise((resolve, reject) => {
        axios.delete(DELETE_SERVICE_URL + '/' + service.Id)
          .then(function() {
            commit(REMOVE_SERVICE, service)
            resolve()
          })
          .catch(error => reject(error))
      })
    },
    updateService({
      commit,
    }, service) {
      return new Promise((resolve, reject) => {
        axios.put(UPDATE_SERVICE_URL, service)
          .then(function(response) {
            commit(UPDATE_SERVICE, response.data)
            resolve()
          })
          .catch(error => reject(error))
      })
    },
    getServices({
      commit,
    }) {
      return new Promise((resolve, reject) => {
        axios.get(GET_SERVICES_URL)
          .then(function(response) {
            commit(SET_SERVICES, response.data)
            resolve()
          })
          .catch(error => reject(error))
      })
    },
    validateService(_, service) {
      return new Promise((resolve, reject) => {
        axios.post(VALIDATE_SERVICE_URL, service)
          .then(function(response) {
            resolve(response.data)
          })
          .catch(error => reject(error))
      })
    },
    async pingServices(_, {
      serviceId,
      serviceIds,
    }) {
      try {
        let response = await axios.post(PING_SERVICES_URL, {
          serviceId,
          serviceIds,
        })
        return response.data
      } catch (error) {
        console.error(error)
        return error.response.data
      }
    },
    async executeService(_, {
      serviceId,
      serviceLink,
      configurationId,
      refreshToken,
      clientId,
      data,
      defaultTimeout,
    }) {
      let processInstanceId = uuidv4()

      try {
        let response = await axios.post(EXECUTE_SERVICE_URL, {
          serviceId,
          serviceLink,
          configurationId,
          refreshToken,
          clientId,
          data,
          defaultTimeout,
        }, {
          params: {
            processInstanceId,
          },
        })

        return response.data
      } catch (error) {
        console.error(error)
        throw error.response.data
      }
    },
    executeServiceProxy(_, {
      serviceId,
      serviceLink,
      payload,
      queryParams,
      subpath,
    }) {
      return axios.post(EXECUTE_SERVICE_PROXY_URL({ serviceId, serviceLink, subpath }), payload, {
        params: queryParams,
      })
    },
  },
  mutations: {
    [ADD_SERVICE](state, service) {
      state.services.push(service)
    },
    [REMOVE_SERVICE](state, service) {
      let index = state.services.findIndex(s => s.Id == service.Id)
      state.services.splice(index, 1)
    },
    [UPDATE_SERVICE](state, service) {
      let index = state.services.findIndex(s => s.Id == service.Id)
      state.services.splice(index, 1, service)
    },
    [SET_SERVICES](state, services) {
      state.services = services
    },
    [RESET](state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
  },
  getters: {
    services: (state) => state.services,
  },
}